import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import useImagePath from '~/composables/useImagePath';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockHeroOrganism',
  props: {
    blockHero: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers,
      $config = _useNuxt2App.$config;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    function selectPromotionEvent(item) {
      var _item$mainImage, _item$image;
      var isCarousel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      $trackers.gtm.pushEvent('select_promotion_carousel', {
        event_category: 'ecommerce',
        event_action: 'click',
        event_label: item === null || item === void 0 ? void 0 : item.title,
        event_name: 'select_promotion',
        page_target: item === null || item === void 0 ? void 0 : item.url,
        ecommerce: {
          creative_name: (item === null || item === void 0 ? void 0 : (_item$mainImage = item.mainImage) === null || _item$mainImage === void 0 ? void 0 : _item$mainImage.fileName) || (item === null || item === void 0 ? void 0 : (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.fileName),
          creative_slot: isCarousel ? "home_carousel_".concat(index + 1) : 'home_slider',
          promotion_name: item === null || item === void 0 ? void 0 : item.title
        }
      });
    }
    function getImage(image) {
      var _image$url;
      return (_image$url = image === null || image === void 0 ? void 0 : image.url) !== null && _image$url !== void 0 ? _image$url : '';
    }
    function viewCarouselEvent(item) {
      var _item$mainImage2, _item$image2, _item$mainImage3, _item$image3;
      var isCarousel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      $trackers.gtm.pushEvent('carousel', {
        event_category: 'ecommerce',
        event_action: 'click',
        event_label: 'view_carousel',
        event_name: 'view_promotion',
        page_target: item === null || item === void 0 ? void 0 : item.url,
        ecommerce: {
          creative_name: (item === null || item === void 0 ? void 0 : (_item$mainImage2 = item.mainImage) === null || _item$mainImage2 === void 0 ? void 0 : _item$mainImage2.fileName) || (item === null || item === void 0 ? void 0 : (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.fileName),
          creative_slot: isCarousel ? "home_carousel_".concat(index + 1) : 'home_slider',
          title: item === null || item === void 0 ? void 0 : item.title,
          image: (item === null || item === void 0 ? void 0 : (_item$mainImage3 = item.mainImage) === null || _item$mainImage3 === void 0 ? void 0 : _item$mainImage3.fileName) || (item === null || item === void 0 ? void 0 : (_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.fileName)
        }
      });
    }

    /**
     * Generates a Cloudinary image URL with the specified width.
     *
     * @param {ImageModel} image - The image object containing the URL.
     * @param {number} width - The desired width of the image.
     * @returns {string} - The generated Cloudinary image URL.
     */
    function generateImageUrl(image, width) {
      var _useImagePath;
      var imagePath = (_useImagePath = useImagePath(image === null || image === void 0 ? void 0 : image.url)) !== null && _useImagePath !== void 0 ? _useImagePath : '';
      return "".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/c_fit,q_auto,f_auto,w_").concat(width, "/b_none/").concat(imagePath);
    }

    /**
     * Generates a `srcset` string for an image with dynamic resolutions.
     *
     * @param {ImageModel} image - The image object containing the URL.
     * @param {number} maxWidth - The maximum width for the resolutions.
     * @param {number} interval - The step interval between resolutions.
     * @returns {string} - The generated `srcset` string.
     */
    function generateSrcset(image, maxWidth, interval) {
      var _useImagePath2;
      var imagePath = (_useImagePath2 = useImagePath(image === null || image === void 0 ? void 0 : image.url)) !== null && _useImagePath2 !== void 0 ? _useImagePath2 : '';
      var srcset = [];
      var currentWidth = maxWidth;
      while (currentWidth >= interval) {
        srcset.push("".concat($config.public.cloudinaryDomain, "/d_default_placeholder.png/c_fit,q_auto,f_auto,w_").concat(currentWidth, "/b_none/").concat(imagePath, " ").concat(currentWidth, "w"));
        currentWidth -= interval;
      }
      return srcset.join(', ');
    }
    onMounted(function () {
      viewCarouselEvent(props.blockHero);
      props.blockHero.slidesCollection.items.forEach(function (item, index) {
        return viewCarouselEvent(item, true, index);
      });
    });
    return {
      __sfc: true,
      props: props,
      $trackers: $trackers,
      $config: $config,
      translate: translate,
      selectPromotionEvent: selectPromotionEvent,
      getImage: getImage,
      viewCarouselEvent: viewCarouselEvent,
      generateImageUrl: generateImageUrl,
      generateSrcset: generateSrcset,
      NuxtLinkCustom: NuxtLinkCustom,
      AzImg: AzImg,
      AzButton: AzButton
    };
  }
});